"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
/**
 * Wrapper class for managing react-native android notifications
 */
class AndroidNotifyWrapper {
    /**
     * Instance constructor.
     * @constructor
     * @param {string} params.applicationId notification application ID
     * @param {AndroidNotifications} params.android android notification instance
     */
    constructor(params) {
        this.applicationId = params.applicationId;
        this.android = params.android;
        this.tokenObservable = this.createTokenObservable();
        this.messageObservable = this.createMessageObservable();
        this.android.consumeBackgroundQueue();
    }
    /**
     * Gets notification microservice application ID
     */
    getApplicationId() {
        return this.applicationId;
    }
    /**
     * Gets transport for this instance
     */
    getTransport() {
        return 'fcm';
    }
    /**
     * Provides token change stream
     */
    asTokenObservable() {
        return this.tokenObservable;
    }
    /**
     * Provides notifications message stream
     */
    asMessageObservable() {
        return this.messageObservable;
    }
    /**
     * Gets mobile token
     */
    getToken() {
        if (this.mobileToken) {
            return Promise.resolve(this.mobileToken);
        }
        else {
            return new Promise((resolve, _reject) => {
                this.asTokenObservable()
                    .first()
                    .subscribe(event => resolve(event.newToken));
                this.android.refreshToken();
            });
        }
    }
    createTokenObservable() {
        const tokenObservable = new rxjs_1.Subject();
        this.android.setRegistrationTokenUpdateListener(newToken => {
            const oldToken = this.mobileToken;
            this.mobileToken = newToken;
            tokenObservable.next({
                oldToken: oldToken,
                newToken: newToken
            });
        });
        return tokenObservable;
    }
    createMessageObservable() {
        const messageObservable = new rxjs_1.Subject();
        const onNotificationReceived = (notification) => messageObservable.next(notification.getData());
        this.android.setNotificationReceivedListener(onNotificationReceived);
        return messageObservable;
    }
}
exports.AndroidNotifyWrapper = AndroidNotifyWrapper;
